import { Pipe, PipeTransform } from '@angular/core';

const siPrefixes = [
  { key: 'T', value: 1e12 },
  { key: 'G', value: 1e9 },
  { key: 'M', value: 1e6 },
  { key: 'k', value: 1e3 },
];

const roundPattern = /\.0*$|(\.[0-9]*[1-9])0+$/;

@Pipe({
  name: 'rtRoundNumber',
  standalone: true,
})
export class RoundNumberPipe implements PipeTransform {
  public transform(value?: number | null): string | number | null {
    if (value === null || value === undefined) return null;
    if (value === 0) {
      return 0;
    }
    if (value < 1000) {
      return value;
    }

    let key;
    let number = value;
    for (let i = 0; i < siPrefixes.length; i++) {
      const reduced = number / siPrefixes[i].value;
      if (reduced >= 1) {
        number = reduced;
        key = siPrefixes[i].key;
        break;
      }
    }
    return number.toFixed(2).slice(0, 4).replace(roundPattern, '$1') + key;
  }
}
